import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDetentionSummary extends Layout {
    buttonViewInNewTab: Button;
    panelTotals: Panel;
    sourceDetentionHistoryLookup: DataSource;
    textboxAverageCharge: Textbox;
    textboxChargeCount: Textbox;
    textboxChargeTotal: Textbox;
    textboxDateRange: Textbox;
    textboxDetentionCount: Textbox;
}
